import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36ac17d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = { class: "nge-shotdlg-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined nge-shotdlg-ico" }, "photo_camera", -1 /* HOISTED */))
const _hoisted_5 = { class: "nge-shotdlg-title" }
const _hoisted_6 = { class: "nge-shotdlg-main" }
const _hoisted_7 = {
  class: "nge-shotdlg-toolbar",
  role: "toolbar",
  "aria-label": "Drawing tools"
}
const _hoisted_8 = {
  class: "nge-shotdlg-tools",
  role: "radiogroup",
  "aria-label": "Tool"
}
const _hoisted_9 = ["aria-checked", "title", "onClick"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-shotdlg-sep",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-shotdlg-tlabel" }, "Colour", -1 /* HOISTED */))
const _hoisted_13 = { class: "nge-shotdlg-swatches" }
const _hoisted_14 = ["onClick", "title", "aria-label", "aria-pressed"]
const _hoisted_15 = ["value"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-shotdlg-sep",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-shotdlg-tlabel" }, "Size", -1 /* HOISTED */))
const _hoisted_18 = ["title", "aria-label"]
const _hoisted_19 = { class: "nge-shotdlg-readout nge-shotdlg-readout-size" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-shotdlg-unit" }, "px", -1 /* HOISTED */))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-shotdlg-sep",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_22 = ["disabled"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "15",
  height: "15",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M9 14l-4-4 4-4" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M5 10h9a5 5 0 0 1 0 10h-3" })
], -1 /* HOISTED */))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Undo", -1 /* HOISTED */))
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = ["disabled"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "15",
  height: "15",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M3 6h18" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M8 6V4h8v2" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M6 6l1 14h10l1-14" })
], -1 /* HOISTED */))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Clear", -1 /* HOISTED */))
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-shotdlg-toolbar-fill" }, null, -1 /* HOISTED */))
const _hoisted_31 = { class: "nge-shotdlg-readout nge-shotdlg-readout-dim" }
const _hoisted_32 = {
  key: 0,
  class: "nge-shotdlg-readout nge-shotdlg-readout-dim nge-shotdlg-readout-src"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-shotdlg-unit" }, "px", -1 /* HOISTED */))
const _hoisted_34 = {
  ref: "stageEl",
  class: "nge-shotdlg-stage"
}
const _hoisted_35 = { class: "nge-shotdlg-clip" }
const _hoisted_36 = {
  ref: "previewEl",
  class: "nge-shotdlg-preview"
}
const _hoisted_37 = ["onKeydown"]
const _hoisted_38 = {
  key: 1,
  class: "nge-shotdlg-wait"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Whole screen capture", -1 /* HOISTED */))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Press Capture screen. The picture appears here, ready to draw on.", -1 /* HOISTED */))
const _hoisted_41 = [
  _hoisted_39,
  _hoisted_40
]
const _hoisted_42 = {
  key: 2,
  class: "nge-shotdlg-wait nge-shotdlg-wait--busy",
  role: "status"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-shotdlg-scan",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "nge-shotdlg-brk tl",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "nge-shotdlg-brk tr",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "nge-shotdlg-brk bl",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "nge-shotdlg-brk br",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_48 = { class: "nge-shotdlg-side" }
const _hoisted_49 = {
  key: 0,
  class: "nge-shotdlg-sec"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "nge-shotdlg-sechead" }, "Output size", -1 /* HOISTED */))
const _hoisted_51 = { class: "nge-shotdlg-dims" }
const _hoisted_52 = { class: "nge-shotdlg-field" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-shotdlg-flabel" }, "Width", -1 /* HOISTED */))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-shotdlg-times" }, "×", -1 /* HOISTED */))
const _hoisted_55 = { class: "nge-shotdlg-field" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-shotdlg-flabel" }, "Height", -1 /* HOISTED */))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-shotdlg-px" }, "px", -1 /* HOISTED */))
const _hoisted_58 = {
  key: 0,
  class: "nge-shotdlg-presets"
}
const _hoisted_59 = ["onClick"]
const _hoisted_60 = { class: "nge-shotdlg-sec" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "nge-shotdlg-sechead" }, "Options", -1 /* HOISTED */))
const _hoisted_62 = { class: "nge-shotdlg-checks" }
const _hoisted_63 = {
  class: "nge-shotdlg-check",
  title: "A picture of the page as you see it, open panels included."
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Whole screen, with panels", -1 /* HOISTED */))
const _hoisted_65 = ["disabled"]
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Transparent background", -1 /* HOISTED */))
const _hoisted_67 = ["disabled"]
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Hide volume edge / bounding box", -1 /* HOISTED */))
const _hoisted_69 = ["disabled"]
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Show scale bar", -1 /* HOISTED */))
const _hoisted_71 = ["disabled"]
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "3D view only", -1 /* HOISTED */))
const _hoisted_73 = { class: "nge-shotdlg-nurro-row" }
const _hoisted_74 = {
  class: "nge-shotdlg-check",
  title: "Put a Nurro in the bottom right corner of the picture"
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Add a Nurro", -1 /* HOISTED */))
const _hoisted_76 = ["src"]
const _hoisted_77 = {
  key: 1,
  class: "nge-shotdlg-err"
}
const _hoisted_78 = { class: "nge-shotdlg-actions" }
const _hoisted_79 = ["disabled"]
const _hoisted_80 = ["disabled"]
const _hoisted_81 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" Teleported to <body> so it always sits above the panel that opened it\n       (Cell Library help request, chat, Scout Tag); inside a panel it was\n       trapped under that panel's stacking layer (Amy 2026-09-29). "),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      ($props.show)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "nge-shotdlg-overlay",
            style: _normalizeStyle($setup.dialogHidden ? 'visibility:hidden' : ''),
            onClick: _withModifiers($setup.close, ["self"])
          }, [
            _createElementVNode("div", {
              class: "nge-shotdlg",
              role: "dialog",
              "aria-label": $setup.props.mode === 'attach' ? 'Attach screenshot' : 'Save screenshot'
            }, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("span", _hoisted_5, _toDisplayString($setup.props.mode === 'attach' ? 'Attach screenshot' : 'Save screenshot'), 1 /* TEXT */),
                _createElementVNode("button", {
                  class: "nge-shotdlg-close",
                  onClick: $setup.close,
                  "aria-label": "Close"
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createCommentVNode(" Pen tools: a HUD strip across the top of the image. "),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.TOOLS, (t) => {
                      return _createElementVNode("button", {
                        key: t.id,
                        type: "button",
                        class: _normalizeClass(["nge-shotdlg-tool nge-shotdlg-tool--pick", { 'is-active': $setup.tool === t.id }]),
                        role: "radio",
                        "aria-checked": $setup.tool === t.id,
                        title: t.title,
                        onClick: $event => {$setup.commitTyping(); $setup.tool = t.id}
                      }, [
                        (_openBlock(), _createElementBlock("svg", {
                          viewBox: "0 0 24 24",
                          width: "15",
                          height: "15",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "1.8",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          innerHTML: t.icon
                        }, null, 8 /* PROPS */, _hoisted_10)),
                        _createElementVNode("span", null, _toDisplayString(t.label), 1 /* TEXT */)
                      ], 10 /* CLASS, PROPS */, _hoisted_9)
                    }), 64 /* STABLE_FRAGMENT */))
                  ]),
                  _hoisted_11,
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.PEN_COLORS, (c) => {
                      return _createElementVNode("button", {
                        key: c,
                        class: _normalizeClass(["nge-shotdlg-swatch", { 'is-active': $setup.activeColor === c }]),
                        style: _normalizeStyle({ '--sw': c }),
                        onClick: $event => ($setup.setColor(c)),
                        title: c,
                        "aria-label": `Pen color ${c}`,
                        "aria-pressed": $setup.activeColor === c
                      }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_14)
                    }), 64 /* STABLE_FRAGMENT */)),
                    _createElementVNode("label", {
                      class: _normalizeClass(["nge-shotdlg-swatch nge-shotdlg-swatch--custom", { 'is-active': $setup.customActive }]),
                      style: _normalizeStyle($setup.customActive ? { '--sw': $setup.activeColor } : {}),
                      title: "Any colour"
                    }, [
                      _createElementVNode("input", {
                        type: "color",
                        value: $setup.customColor,
                        onInput: $setup.pickCustom,
                        onClick: _cache[0] || (_cache[0] = $event => ($setup.setColor($setup.customColor))),
                        "aria-label": "Pick any pen colour"
                      }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_15)
                    ], 6 /* CLASS, STYLE */)
                  ]),
                  _hoisted_16,
                  _hoisted_17,
                  _withDirectives(_createElementVNode("input", {
                    type: "range",
                    min: "1",
                    max: "12",
                    step: "1",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.penSize) = $event)),
                    class: "nge-shotdlg-pen-size",
                    title: $setup.tool === 'text' ? `Text size: ${$setup.textPx($setup.penSize)}px` : `Line width: ${$setup.penSize}px`,
                    "aria-label": $setup.tool === 'text' ? 'Text size' : 'Line width'
                  }, null, 8 /* PROPS */, _hoisted_18), [
                    [
                      _vModelText,
                      $setup.penSize,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _createElementVNode("span", _hoisted_19, [
                    _createTextVNode(_toDisplayString($setup.tool === 'text' ? $setup.textPx($setup.penSize) : $setup.penSize), 1 /* TEXT */),
                    _hoisted_20
                  ]),
                  _hoisted_21,
                  _createElementVNode("button", {
                    class: "nge-shotdlg-tool",
                    onClick: $setup.undo,
                    disabled: !$setup.strokes.length,
                    title: "Undo last stroke"
                  }, _hoisted_25, 8 /* PROPS */, _hoisted_22),
                  _createElementVNode("button", {
                    class: "nge-shotdlg-tool",
                    onClick: $setup.clearMarkup,
                    disabled: !$setup.strokes.length,
                    title: "Clear all marks"
                  }, _hoisted_29, 8 /* PROPS */, _hoisted_26),
                  _hoisted_30,
                  _createElementVNode("span", _hoisted_31, "Marks " + _toDisplayString($setup.strokes.length), 1 /* TEXT */),
                  ($setup.sourceRef)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                        _createTextVNode(" Src " + _toDisplayString($setup.sourceRef.sw) + " × " + _toDisplayString($setup.sourceRef.sh), 1 /* TEXT */),
                        _hoisted_33
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                _createCommentVNode(" Stage: the preview frame is fitted in here at the output aspect. "),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", {
                    class: "nge-shotdlg-frame",
                    style: _normalizeStyle({ width: $setup.frameCss.w + 'px', height: $setup.frameCss.h + 'px' })
                  }, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("canvas", _hoisted_36, null, 512 /* NEED_PATCH */),
                      _createElementVNode("canvas", {
                        ref: "markupEl",
                        class: _normalizeClass(["nge-shotdlg-markup", `nge-shotdlg-markup--${$setup.tool}`]),
                        onPointerdown: $setup.onPointerDown,
                        onPointermove: $setup.onPointerMove,
                        onPointerup: $setup.onPointerUp,
                        onPointercancel: $setup.onPointerUp
                      }, null, 34 /* CLASS, HYDRATE_EVENTS */),
                      _createCommentVNode(" The text tool's box, where the click was; Enter keeps it. "),
                      ($setup.typing)
                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 0,
                            ref: "typingEl",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.typing.value) = $event)),
                            class: "nge-shotdlg-typing",
                            style: _normalizeStyle({ left: ($setup.typing.x - 3) + 'px', top: ($setup.typing.y - 1) + 'px', color: $setup.textColor, fontSize: $setup.textPx($setup.penSize) + 'px' }),
                            maxlength: "200",
                            placeholder: "Type, then Enter",
                            "aria-label": "Text to add to the picture",
                            onKeydown: _withModifiers($setup.onTypingKey, ["stop"]),
                            onKeyup: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
                            onKeypress: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
                            onBlur: $setup.commitTyping
                          }, null, 44 /* STYLE, PROPS, HYDRATE_EVENTS */, _hoisted_37)), [
                            [_vModelText, $setup.typing.value]
                          ])
                        : _createCommentVNode("v-if", true),
                      ($setup.wholeScreen && !$setup.screenCap)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, _hoisted_41))
                        : _createCommentVNode("v-if", true),
                      _createCommentVNode(" The longest wait in the app: a cell grows while it runs, and\n                   a long one cycles through the kinds (Ames 2026-10-06). Not\n                   shown while a whole screen capture is being taken, when\n                   the dialog itself is hidden. "),
                      ($setup.busy && ($setup.screenCap || !$setup.wholeScreen))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                            _createVNode($setup["GrowingCell"], { size: 150 }),
                            _createElementVNode("b", null, _toDisplayString($setup.props.mode === 'attach' ? 'Uploading' : 'Saving'), 1 /* TEXT */)
                          ]))
                        : _createCommentVNode("v-if", true),
                      _hoisted_43
                    ]),
                    _hoisted_44,
                    _hoisted_45,
                    _hoisted_46,
                    _hoisted_47
                  ], 4 /* STYLE */)
                ], 512 /* NEED_PATCH */)
              ]),
              _createCommentVNode(" Right bar: output, options, actions. "),
              _createElementVNode("div", _hoisted_48, [
                ($setup.props.mode !== 'attach')
                  ? (_openBlock(), _createElementBlock("section", _hoisted_49, [
                      _hoisted_50,
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("label", _hoisted_52, [
                          _hoisted_53,
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($setup.width) = $event)),
                            min: "16",
                            max: "8192"
                          }, null, 512 /* NEED_PATCH */), [
                            [
                              _vModelText,
                              $setup.width,
                              void 0,
                              { number: true }
                            ]
                          ])
                        ]),
                        _hoisted_54,
                        _createElementVNode("label", _hoisted_55, [
                          _hoisted_56,
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($setup.height) = $event)),
                            min: "16",
                            max: "8192"
                          }, null, 512 /* NEED_PATCH */), [
                            [
                              _vModelText,
                              $setup.height,
                              void 0,
                              { number: true }
                            ]
                          ])
                        ]),
                        _hoisted_57
                      ]),
                      ($setup.props.mode !== 'attach')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.PRESETS, (p) => {
                              return _createElementVNode("button", {
                                key: p.label,
                                class: _normalizeClass({ 'is-active': $setup.isPreset(p.w, p.h) }),
                                onClick: $event => ($setup.preset(p.w, p.h))
                              }, [
                                _createElementVNode("b", null, _toDisplayString(p.label), 1 /* TEXT */),
                                _createElementVNode("span", null, _toDisplayString(p.w) + " × " + _toDisplayString(p.h), 1 /* TEXT */)
                              ], 10 /* CLASS, PROPS */, _hoisted_59)
                            }), 64 /* STABLE_FRAGMENT */))
                          ]))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("section", _hoisted_60, [
                  _hoisted_61,
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("label", _hoisted_63, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($setup.wholeScreen) = $event))
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelCheckbox, $setup.wholeScreen]
                      ]),
                      _hoisted_64
                    ]),
                    _createElementVNode("label", {
                      class: _normalizeClass(["nge-shotdlg-check", { 'is-off': $setup.wholeScreen }])
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (($setup.transparent) = $event)),
                        disabled: $setup.wholeScreen
                      }, null, 8 /* PROPS */, _hoisted_65), [
                        [_vModelCheckbox, $setup.transparent]
                      ]),
                      _hoisted_66
                    ], 2 /* CLASS */),
                    _createElementVNode("label", {
                      class: _normalizeClass(["nge-shotdlg-check", { 'is-off': $setup.wholeScreen }])
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => (($setup.hideBoundingBox) = $event)),
                        disabled: $setup.wholeScreen
                      }, null, 8 /* PROPS */, _hoisted_67), [
                        [_vModelCheckbox, $setup.hideBoundingBox]
                      ]),
                      _hoisted_68
                    ], 2 /* CLASS */),
                    _createElementVNode("label", {
                      class: _normalizeClass(["nge-shotdlg-check", { 'is-off': $setup.wholeScreen }])
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (($setup.showScaleBar) = $event)),
                        disabled: $setup.wholeScreen
                      }, null, 8 /* PROPS */, _hoisted_69), [
                        [_vModelCheckbox, $setup.showScaleBar]
                      ]),
                      _hoisted_70
                    ], 2 /* CLASS */),
                    _createElementVNode("label", {
                      class: _normalizeClass(["nge-shotdlg-check", { 'is-off': $setup.wholeScreen }]),
                      title: "Crop to the 3D view"
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => (($setup.only3d) = $event)),
                        disabled: $setup.wholeScreen
                      }, null, 8 /* PROPS */, _hoisted_71), [
                        [_vModelCheckbox, $setup.only3d]
                      ]),
                      _hoisted_72
                    ], 2 /* CLASS */)
                  ]),
                  _createElementVNode("div", _hoisted_73, [
                    _createElementVNode("label", _hoisted_74, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => (($setup.nurroOn) = $event))
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelCheckbox, $setup.nurroOn]
                      ]),
                      _hoisted_75
                    ]),
                    _createElementVNode("img", {
                      src: $setup.nurroSrc,
                      alt: "",
                      class: _normalizeClass(["nge-shotdlg-nurro-thumb", { 'is-on': $setup.nurroOn }]),
                      onClick: $setup.nextNurro,
                      title: "Click for another Nurro"
                    }, null, 10 /* CLASS, PROPS */, _hoisted_76),
                    _createElementVNode("button", {
                      class: "nge-shotdlg-nurro-next",
                      onClick: $setup.nextNurro,
                      title: "Another Nurro"
                    }, "another")
                  ])
                ]),
                ($setup.errorMsg)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_77, _toDisplayString($setup.errorMsg), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_78, [
                  _createElementVNode("button", {
                    class: "nge-shotdlg-primary",
                    onClick: $setup.download,
                    disabled: $setup.busy
                  }, _toDisplayString($setup.busy
                ? ($setup.wholeScreen && !$setup.screenCap ? 'Capturing…' : $setup.props.mode === 'attach' ? 'Uploading…' : 'Rendering…')
                : ($setup.wholeScreen && !$setup.screenCap ? 'Capture screen' : $setup.props.mode === 'attach' ? 'Attach' : 'Download')), 9 /* TEXT, PROPS */, _hoisted_79),
                  ($setup.wholeScreen && $setup.screenCap)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "nge-shotdlg-cancel",
                        onClick: $setup.retake,
                        disabled: $setup.busy
                      }, "Retake", 8 /* PROPS */, _hoisted_80))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("button", {
                    class: "nge-shotdlg-cancel",
                    onClick: $setup.close,
                    disabled: $setup.busy
                  }, "Cancel", 8 /* PROPS */, _hoisted_81)
                ])
              ])
            ], 8 /* PROPS */, _hoisted_2)
          ], 12 /* STYLE, PROPS */, _hoisted_1))
        : _createCommentVNode("v-if", true)
    ]))
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}